const trim = (value) => (value == null ? "" : String(value).trim());

/** Builds "רחוב 10, קומה 2, דירה 6" from partial address fields. */
export function formatStreetLine(fields = {}) {
  const street = trim(fields.streetName ?? fields.addrStreet);
  const house = trim(fields.houseNumber ?? fields.addrHouse);
  const floor = trim(fields.floor ?? fields.addrFloor);
  const apartment = trim(fields.apartment ?? fields.addrApartment);

  const parts = [];
  const streetHouse = [street, house].filter(Boolean).join(" ");
  if (streetHouse) parts.push(streetHouse);
  if (floor) parts.push(`קומה ${floor}`);
  if (apartment) parts.push(`דירה ${apartment}`);
  return parts.join(", ");
}

/** Normalized display lines for address cards (private area + checkout). */
export function formatAddressLines(source = {}) {
  const name =
    [
      source.addrOrderRecipientName,
      source.localRecipientName,
      source.name,
      source.lastName,
    ]
      .map(trim)
      .find(Boolean) || "";
  const streetLine = formatStreetLine(source);
  const city = trim(source.city ?? source.addrCity ?? source.localCity);
  const zip = trim(source.zipCode ?? source.addrZipCode);

  const secondaryParts = [];
  if (city) secondaryParts.push(city);
  if (zip) secondaryParts.push(`מיקוד ${zip}`);

  return {
    name,
    streetLine,
    secondaryLine: secondaryParts.join(" · "),
    hasData: !!(name || streetLine || city || zip),
  };
}
